import { FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';
import { DropDown, DropDownItem } from '../Dropdown';

interface IOptionsProps {
  isEditable: boolean;
  property: string;
  options: any[];
  value: string | number | undefined;
  onSelect: (val) => void;
}
const Options: FC<IOptionsProps> = ({ isEditable, property, options, value, onSelect }) => (
  <FlexLayout alignItems="center" width="full">
    <DropDown placeholder="Select" onChange={onSelect} defaultValue={value} disabled={!isEditable}>
      {options.map(option => (
        <DropDownItem value={option} key={option}>
          <H4 style={{ textTransform: 'capitalize' }}>{option}</H4>
        </DropDownItem>
      ))}
    </DropDown>
  </FlexLayout>
);

export default Options;
